import React, { useState, useEffect } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "./../components/Search";
import CreateIcon from "../components/Create";
import { reqGetListAgents, reqGetListCustomers } from "../../../reduxs/cms/action";
import EditCustomerModal from "./EditCustomerModal";
import "./index.scss";
import AddCustomerModal from "./AddCustomerModal";
import { toast } from "react-toastify";
import CustomerFavoritesModal from "./CustomerFavoritesModal";
import customersAPI from '../../../apis/api/customer';
import { ReactComponent as ArrowRight } from "../../../assets/images/arrow-right.svg";

export const PurchaseOptions = [
  { label: "Primary Residence", value: "Primary Residence" },
]

const Row = ({ data, onEditCustomer, onViewFavorite, onSaveSuccess }) => {
  const [show, setShow] = useState(false);

  const handleCopyURL = () => {
    if (!data) return;
    const url = data?.uniqueUrl || `${process.env.REACT_APP_URL}/post-engagement/${data?.id}`;
    navigator.clipboard.writeText(url);
    toast.success('Copied customer session url!');
  }

  const handleUpdateActive = async (e) => {
    if (!data) return;
		
		try {
			const updated = {
				isActive: e?.target?.checked || false,
			};
			const res = await customersAPI.updateCustomer(data.id, updated);
			if (res.data) {
				toast.success("Customer updated successfully!"); 
				onSaveSuccess && onSaveSuccess();
			}
		} catch (err) {
			toast.error(err.message);
		}
  }

  return (
		<div className={`content-row`}>
      <div>{data?.firstname}</div>
      <div>{data?.surname}</div>
      <div>{data?.email}</div>
      <div>{data?.agent?.name || ''}</div>
      <div className="action-view" onClick={() => onViewFavorite?.(data)}>
        <div>VIEW</div>
        <div><ArrowRight /></div>
      </div>
      <div className="url action-copy" onClick={() => handleCopyURL()}>
        <div>COPY</div>
        <div><ArrowRight /></div>
      </div>
      <div className="status">
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="customer-state-1"
            defaultChecked={data?.isActive}
            onChange={handleUpdateActive}
          />
          <label className="form-check-label" htmlFor="customer-state-1" />
        </div>
      </div>
      <div onClick={() => onEditCustomer?.(data)}>
        <div className="action-edit">
          <img className="img-fluid" src="/icons/edit-button.svg" alt="" />
        </div>
      </div>
    </div>
  );
}

const CMSCustomers = () => {
  const dispatch = useDispatch();

  const [isShowEditCustomerModal, setIsShowEditCustomerModal] = useState(false);
  const [isShowAddCustomerModal, setIsShowAddCustomerModal] = useState(false);
  const [isShowCustomerFavoritesModal, setIsShowCustomerFavoritesModal] = useState(false);
  const [seletedCustomer, setSelectedCustomer] = useState(null);
  const [search, setSearch] = useState('');
  const [isSortAsc, toggleSortAsc] = useState(true);

  const customers = useSelector((state) => state.cms.customers);

  useEffect(() => {
    getListCustomers();
  }, [search, isSortAsc])

  useEffect(() => {
    getListCustomers();
    getListAgents();
  }, []);

  const getListCustomers = () => {
    dispatch(reqGetListCustomers({
      search,
      sortBy: JSON.stringify({
        name: isSortAsc ? 1 : -1,
      }),
    }));
  }

  const getListAgents = () => {
    dispatch(reqGetListAgents({
      sortBy: JSON.stringify({
        name: 1,
      }),
      isActive: true,
    }));
  }

  const onSaveSuccess = () => {
    getListCustomers();
  }

  const onCreateSuccess = () => {
    getListCustomers();
  }

  const onEditCustomer = (customer) => {
    setSelectedCustomer(customer);
    setIsShowEditCustomerModal(true);
  }

  const onAddNewCustomer = () => {
    setIsShowAddCustomerModal(true);
  }

  const onViewFavorite = (customer) => {
    setSelectedCustomer(customer);
    setIsShowCustomerFavoritesModal(true);
  }

  const onSearch = (e) => {
    setSearch(e.target?.value);
  } 

  const renderListProperty = () => {
    return (customers || []).map((item, index) => {
      return (
        <Row
          key={item.id}
          data={item}
          index={index}
          onEditCustomer={onEditCustomer}
          onViewFavorite={onViewFavorite}
          onSaveSuccess={onSaveSuccess}
        />
      );
    });
  };

  const renderContent = () => {
    return (
      <div className="content">
				<div className="content-header">
          <div>FIRST NAME</div>
          <div>LAST NAME</div>
          <div>EMAIL</div>
          <div>AGENT</div>
          <div>FAVORITES</div>
          <div>URL</div>
          <div>ACTIVE</div>
          <div></div>
				</div>
				<div className="content-list">
          {renderListProperty()}
        </div>
			</div>
    );
  };

  return (
    <div className="page-container">
      <div className="page-header d-flex align-items-center">
        <h1 className="f-title mb-0">CUSTOMERS</h1>
      </div>
      <div className="page-body customers-page-body">
        {renderContent()}
        <div className="add-btn-container" onClick={onAddNewCustomer}>
          <CreateIcon createCustomer={true}/>
        </div>
      </div>
      { isShowEditCustomerModal &&
        <EditCustomerModal 
          show={isShowEditCustomerModal}
          setShow={setIsShowEditCustomerModal}
          customer={seletedCustomer}
          onSaveSuccess={onSaveSuccess}
        />
      }
      {
        isShowAddCustomerModal &&
        <AddCustomerModal
          show={isShowAddCustomerModal}
          setShow={setIsShowAddCustomerModal}
          onCreateSuccess={onCreateSuccess}
        />
      }
      {
        isShowCustomerFavoritesModal && 
        <CustomerFavoritesModal
          show={isShowCustomerFavoritesModal}
          setShow={setIsShowCustomerFavoritesModal}
          customer={seletedCustomer}
        />
      }
      
      {/* <SearchIcon handleInputChange={onSearch}/> */}
    </div>
  );
};
export default CMSCustomers;
